let modalPlayer; // グローバル変数として宣言

// YouTube Iframe APIの読み込み YouTube IFrame APIが準備完了したときに自動的に実行
function onYouTubeIframeAPIReady() {
  modalPlayer = new YT.Player("modal-player", {
    height: "100%",
    width: "100%",
    videoId: "",
    playerVars: {
      autoplay: 1,
      controls: 1,
      modestbranding: 1,
      rel: 0,
    },
  });

  $("#youtube-modal").on("click", function (e) {
    if (
      $(e.target).is(
        "#youtube-modal, .youtube-modal__bg, .youtube-modal__close"
      )
    ) {
      $(this).fadeOut();
      modalPlayer.stopVideo();
      $("body").css("overflow", "auto");
    }
  });
}

// スライダー
window.addEventListener("load", () => {
  $(".youtube-slider").each(function () {
    if (!$(this).hasClass("slick-initialized")) {
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
      });
    }
  });
});

// KVビデオのON/OFF切り替え
document.addEventListener("DOMContentLoaded", () => {
  const video = document.querySelector("video");
  if (!video) return;

  const muteBtn = document.querySelector(".toggle-audio-btn.Mute");
  const playBtn = document.querySelector(".toggle-audio-btn.Play");

  video.muted = true;
  muteBtn.style.display = "block";
  playBtn.style.display = "none";

  muteBtn.addEventListener("click", () => {
    video.muted = false;
    muteBtn.style.display = "none";
    playBtn.style.display = "block";
  });

  playBtn.addEventListener("click", () => {
    video.muted = true;
    muteBtn.style.display = "block";
    playBtn.style.display = "none";
  });
});

// YouTubeモーダルのトリガー
$(document).on("click", ".youtube-modal__trigger", function () {
  const videoId = $(this).data("video-id");

  // KVビデオをミュートする
  const kvVideo = document.querySelector("video");
  if (kvVideo && !kvVideo.muted) {
    kvVideo.muted = true;

    const muteBtn = document.querySelector(".toggle-audio-btn.Mute");
    const playBtn = document.querySelector(".toggle-audio-btn.Play");
    if (muteBtn && playBtn) {
      muteBtn.style.display = "block";
      playBtn.style.display = "none";
    }
  }

  // modalPlayerが存在し、videoIdがある場合のみ実行
  if (modalPlayer && videoId) {
    modalPlayer.loadVideoById(videoId);
    $("#youtube-modal").fadeIn();
    $("body").css("overflow", "hidden");
  }
});